import { render } from "./EmailConsultPanel.vue?vue&type=template&id=0bded11f&scoped=true"
import script from "./EmailConsultPanel.vue?vue&type=script&lang=js"
export * from "./EmailConsultPanel.vue?vue&type=script&lang=js"

import "./EmailConsultPanel.vue?vue&type=style&index=0&id=0bded11f&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0bded11f"]])

export default __exports__